import { number } from "../../../../config";

export const menuItems = [
  {
    key: number.ONE,
    text: "In 1 hour",
  },
  {
    key: number.TWO,
    text: "In 3 hours",
  },
  {
    key: number.THREE,
    text: "Tomorrow",
  },
  {
    key: number.FOUR,
    text: "Custom",
  },
];
